export default {
  forgot_password_submit: {
    title: 'パスワードリセット',
    submit_complete: '送信完了',
    password_reset: 'パスワードリセットされました。',
  },
}
